import {Component, Inject, Optional} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule} from "@angular/material/dialog";
import {ReminderResponse, ReminderTabIndex} from "../../Models/dashboard.model";
import {DashboardUtilService} from "../../Services/dashboard-util.service";
import {SharedModule} from "../../../../modules/shared/shared.module";
import {NumberInput} from "@angular/cdk/coercion";
import {AddEditReminderComponent} from "../add-edit-reminder/add-edit-reminder.component";
import {ToastrService} from "ngx-toastr";
import {UserConsentDialogComponent} from "../../../Shared/user-consent-dialog/user-consent-dialog.component";
import {DashboardService} from "../../Services/dashboard.service";
import {SharedService} from "../../../../services/shared.service";
import {HandleErrorService} from "../../../../services/handle-error-service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {DashReminderCardComponent} from "../dash-reminder-card/dash-reminder-card.component";
import {MatTabsModule} from "@angular/material/tabs";
import {MatButtonModule} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";

@Component({
    selector: "app-reminders",
    imports: [CommonModule, SharedModule, DashReminderCardComponent, MatTabsModule, MatDialogModule, MatButtonModule, MatIcon],
    templateUrl: "./reminders.component.html",
    styleUrls: ["./reminders.component.scss"]
})
export class RemindersComponent {
    selectedReminderTabIndex: NumberInput;
    destroy$: Subject<void> = new Subject<void>();
    pastReminders: ReminderResponse[];
    futureReminders: ReminderResponse[];
    todayReminders: ReminderResponse[];
    protected readonly ReminderTabIndex = ReminderTabIndex;

    constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        private data: {
            reminderTabIndex: number;
        },
        private dashBoardUtilService: DashboardUtilService,
        private dialog: MatDialog,
        private toast: ToastrService,
        private dashboardService: DashboardService,
        private sharedService: SharedService,
        private handleErrorService: HandleErrorService,
    ) {}

    ngOnInit() {
        if (this.data) {
            this.selectedReminderTabIndex = this.data.reminderTabIndex;
        }

        this.dashboardService.reminders$.pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
                if (data) {
                    this.pastReminders = data.pastReminders ? data.pastReminders : [];
                    this.futureReminders = data.futureReminders ? data.futureReminders : [];
                    this.todayReminders = data.todayReminders ? data.todayReminders : [];
                } else {
                    this.pastReminders = [];
                    this.futureReminders = [];
                    this.todayReminders = [];
                }
            },
        });
    }

    viewReminderEvent($event: ReminderResponse, tabIndex: number) {
        this.dialog
            .open(AddEditReminderComponent, {
                width: "500px",
                autoFocus: false,
                disableClose: true,
                data: $event,
            })
            .afterClosed()
            .subscribe({
                next: (data) => {
                    if (data) {
                        this.updateReminderData(new ReminderResponse(data), tabIndex);
                    }
                },
            });
    }

    updateReminderData($event: ReminderResponse, tabIndex: number) {
        this.dashboardService.updateReminderFromDashboard($event, tabIndex);
    }

    markAsDoneEvent($event: ReminderResponse, tabIndex: number) {
        const dialogRef = this.dialog.open(UserConsentDialogComponent, {
            maxWidth: "20vw",
            data: {
                title: "Mark Reminder as Done",
                message: "This reminder will be permanently disabled. Are you sure you want to continue?",
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === "true") {
                this.dashboardService
                    .markReminderAsDone($event, this.sharedService.getAllAccountIdsOfLoggedInUser() as string)
                    .subscribe({
                        next: (response) => {
                            this.toast.success("Reminder Updated Successfully", "Success");
                            this.updateReminderData(new ReminderResponse(response.data), tabIndex);
                        },
                        error: (error) => {
                            this.handleErrorService.handleError(error);
                        },
                    });
            }
        });
    }

    addNewReminder() {
        this.dialog
            .open(AddEditReminderComponent, {
                width: "500px",
                autoFocus: false,
                disableClose: true,
            })
            .afterClosed()
            .subscribe({
                next: (data) => {
                    if (data) {
                        this.dashboardService.addNewReminderFromDashboard(data);
                    }
                },
            });
    }

}
